








































import { AppState } from "../shared/types/AppState";
import DB from "../shared/DB";
import Aux from "../shared/Aux";
import { Component, Vue } from "vue-property-decorator";
import Clickbutton from "@/components/Clickbutton.vue";
import TranslationsActionsPane from "@/components/TranslationsActionsPane.vue";
import TranslationsLocaleSelector from "@/components/TranslationsLocaleSelector.vue";
import TranslationsKeyValuePairRow from "@/components/TranslationsKeyValuePairRow.vue";
import AccountLock from "@/components/AccountLock.vue";

@Component(
{
	components: {
		Clickbutton,
		TranslationsActionsPane,
		TranslationsLocaleSelector,
		TranslationsKeyValuePairRow,
		AccountLock
	}
})

export default class Item extends Vue
{
	data()
	{
		return {
			model: {
				files: {},
				filesLoadedDateTime: "",
				locales: [],
				selectedLocale: "",
				appState: AppState.Opened
			},
			AppState: AppState
		};
	}

	onTranslationsValueChanged()
	{
		(this as any).model.appState = AppState.AwaitingSave;
	}

	translationsLocaleSelectorChanged(val: string)
	{
		localStorage.setItem("selectedlocale", val);
	}

	getFiles()
	{
		const db = new DB();

		db.getFiles((files) =>
		{
			console.log("mounted() All", files);

			(this as any).model.locales = Aux.extractLocales(files);
			(this as any).model.files = files;
			(this as any).model.selectedLocale = localStorage.getItem("selectedlocale") || (this as any).model.locales[0];
		});
	}

	mounted()
	{
		(this as any).AppState = AppState.AwaitingSave;

		this.getFiles();
	}

	discard()
	{
		if (confirm("Discard changes?"))
		{
			(this as any).model.appState = AppState.Opened;
			(this as any).model.filesLoadedDateTime = Date.now() / 1000 | 0;

			this.getFiles();
		}
	}

	save()
	{
		(this as any).model.appState = AppState.Saving;

		const db = new DB();

		db.updateFiles((this as any).model.files, () =>
		{
			(this as any).model.appState = AppState.Saved;

			setTimeout(() =>
			{
				(this as any).model.appState = AppState.Opened;
			}, 2000);
		});
	}
}
